import { motion } from "framer-motion";

interface KOPipelineStepProps {
  step: number;
  title: string;
  children: React.ReactNode;
}

const KOPipelineStep = ({ step, title, children }: KOPipelineStepProps) => {
  return (
    <div className="relative">
      {/* Step connector */}
      <motion.div
        className="flex items-center gap-4 mb-8"
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex-shrink-0 w-14 h-14 rounded-full bg-primary text-white flex items-center justify-center text-xl font-bold shadow-lg shadow-primary/25">
          {step}
        </div>
        <div>
          <p className="text-sm font-medium text-primary uppercase tracking-wider">Step {step}</p>
          <h3 className="text-2xl md:text-3xl font-bold">{title}</h3>
        </div>
      </motion.div>
      {children}
    </div>
  );
};

export default KOPipelineStep;
